export const LOCAL_STORAGE_TOKEN_NAME = 'adobe_token';